import { ThemeProvider } from "@emotion/react";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import store from "./store";
import { createAppTheme } from "./utils/AppTheme";
import { Home } from "./components/pages/Home";
import Login from "./components/pages/Login";
import { CreatePage } from "./components/pages/Create";
import PrivateRoute from "./components/utils/PrivateRoute";
import { DashboardPage } from "./components/pages/Dashboard";
import Header from "./components/layout/header";
import Payment from "./components/pages/Payment";
import NotFoundPage from "./components/layout/404";
import { Box, CssBaseline } from "@mui/material";
import { PurchaseOrderPage } from "./components/pages/PurchaseOrder";
import MobileBottomNavigation from "./components/layout/mobileBottomNavigation";
import { PurchasersPage } from "./components/pages/Purchasers";
import { WinnersPage } from "./components/pages/Winners";
import { SuccessPurchasePage } from "./components/pages/SuccessPurchase";
import { SoldTicketsPage } from "./components/pages/SoldTickets";
import { TicketsFinderPage } from "./components/pages/TicketsFinder";
import { ConfigurationPage } from "./components/pages/Configuration";
import { ReportsPage } from "./components/pages/Reports";
import { Chart, registerables } from 'chart.js';
import { SelfVerificationPage } from "./components/pages/SelfVerification";
import { PendingWorkPage } from "./components/pages/PendingWork";
import { AccountsPage } from "./components/pages/Accounts";
import { RafflesPage } from "./components/pages/Raffles";
import { ReporteFacturacionPage } from "./components/pages/ReporteFacturacion";
import SidebarHeader from "./components/layout/sidebar";
import { RafflePage } from "./components/pages/RafflePage";
Chart.register(...registerables);
function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={createAppTheme(store.getState())}>
        <CssBaseline />
        <SnackbarProvider>
            <BrowserRouter>
            <Header></Header>
            <SidebarHeader />
             <Box>
              <Routes>
                  <Route path={"/"} element={<Home />} />
                  <Route path={"/rifa/:raffleId"} element={<RafflePage />} />
                  <Route path={"/successPurchase"} element={<SuccessPurchasePage />} />
                  <Route path={"/purchaseOrders"} element={
                    <PrivateRoute>
                      <PurchaseOrderPage key={"po"} />
                    </PrivateRoute>
                  } />
                  <Route path={"/pendingWork"} element={
                    <PrivateRoute>
                      <PendingWorkPage />
                    </PrivateRoute>
                  } />
                  <Route path={"/create"} element={
                    <PrivateRoute>
                      <CreatePage />
                    </PrivateRoute>
                  } />
                  <Route path={"/purchasers"} element={
                    <PrivateRoute>
                      <PurchasersPage />
                    </PrivateRoute>
                  } />
                  <Route
                      path={"/dashboard"}
                      element={
                        <PrivateRoute>
                          <DashboardPage key={"dashboard"} />
                        </PrivateRoute>
                      }
                    />
                  <Route
                      path={"/accounts"}
                      element={
                        <PrivateRoute>
                          <AccountsPage key={"accounts"} />
                        </PrivateRoute>
                      }
                    />
                  <Route
                      path={"/raffles"}
                      element={
                        <PrivateRoute>
                          <RafflesPage key={"raffles"} />
                        </PrivateRoute>
                      }
                    />
                  <Route
                      path={"/ticketsFinder"}
                      element={
                        <TicketsFinderPage />
                      }
                    />
                  <Route
                      path={"/self-verification/:email"}
                      element={
                        <SelfVerificationPage />
                      }
                    />
                  <Route
                      path={"/configuration"}
                      element={
                        <PrivateRoute>
                          <ConfigurationPage  />
                        </PrivateRoute>
                      }
                    />
                  <Route
                      path={"/reports"}
                      element={
                        <PrivateRoute>
                          <ReportsPage  />
                        </PrivateRoute>
                      }
                    />
                  <Route
                      path={"/reporte-facturacion"}
                      element={
                        <PrivateRoute>
                          <ReporteFacturacionPage  />
                        </PrivateRoute>
                      }
                    />
                  <Route path={"/winners"} element={
                    <PrivateRoute>
                      <WinnersPage />
                    </PrivateRoute>
                  } />
                  <Route path={"/soldTickets"} element={
                    <PrivateRoute>
                      <SoldTicketsPage />
                    </PrivateRoute>
                  } />
                  <Route path={"/login"} element={<Login/>} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
             </Box>
             <MobileBottomNavigation />
            </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
